<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle toCapitalize">{{locale.product_set_order}}</h2>
      <!-- category -->
      <div class="mb15">
        <div class="category mb5">
          <button type="button" class="btn"
            v-for="item in category"
            :key="item.data.id"
            :class="{
              btnWhite: filter !== item.data.id}"
            @click="setFilter(item.data.id)">
            {{item.data.label[lang.default]}}
          </button>
        </div>
      </div>
      <!-- //category -->
      <!-- product items -->
      <draggable class="setOrder"
        tag="div"
        v-model="activeList"
        v-bind="dragOptions">
        <transition-group type="transition"
          class="productList"
          tag="div">
          <div class="productItem"
            v-for="item in activeList"
            :key="item.id"
            :class="{hide: !item.service}">
            <div class="thumb">
              <img v-if="item.thumb" :src="item.thumb" alt="" />
              <img v-else src="@/assets/img/img_product_default.png" alt="" class="defaultImg">
            </div>
            <div v-if="item.category" class="itemCategory">
              <span
                v-for="category in item.category.filter(x => isActiveCategory(x))"
                :key="category">
                {{getCategoryName(category)}}
              </span>
            </div>
            <p class="name">{{item.info.pName}}</p>
          </div>
        </transition-group>
      </draggable>
      <div class="setApply">
        <button type="button" class="btn btnPrimary btnFull toUppercase" @click="onApply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: [
    'locale',
    'lang'
  ],
  components: {
    draggable
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    category () {
      const categoryAll = this.$store.getters['product/getCategory']
      const unCategorized = categoryAll.filter(x => x.data.id === '')
      const addedCategory = categoryAll.filter(x => x.data.id !== '')
      return unCategorized.length && !unCategorized.length ? [] : addedCategory
    },
    order () { // (legacy) order list or (new) order data
      return this.$store.getters['product/getOrder']
    }
  },
  watch: {
    activeList: {
      deep: true,
      handler (data) {
        const category = this.filter
        this.filtered[category] = data
      }
    }
  },
  mounted () {
    if (Array.isArray(this.order)) {
      this.orderList = [...new Set(this.order)]
      this.productByFilter()
    } else {
      this.filtered = this._.cloneDeep(this.order)
    }
    if (this.category.length) {
      this.setFilter(this.category[0].data.id)
    } else {
      this.setFilter('unCategorized')
    }
  },
  data () {
    return {
      orderList: [],
      filter: '',
      filtered: {},
      activeList: []
    }
  },
  methods: {
    setFilter (categoryId) {
      this.filter = categoryId
      this.activeList = this.filtered[categoryId]
    },
    productByFilter () {
      const list = this.orderList
      const category = this.category
      if (category && category.length) {
        for (let i = 0; i < category.length; i++) {
          const cate = category[i]
          const cateId = cate.data.id
          this.filtered[cateId] = list.filter(x => {
            return x.category
              ? x.category.filter(c => cate.data.id === c || (cate.childrenIds && cate.childrenIds.includes(c))).length > 0
              : x.info.category
                ? cate.childrenIds.includes(x.info.category)
                : false
          })
        }
      } else {
        this.filtered = { unCategorized: list }
        this.activeList = list
      }
    },
    isActiveCategory (id) {
      const active = this.filter
      const category = this.category.find(x => x.data.id === active)
      return id === active || (category && category.childrenIds && category.childrenIds.includes(id))
    },
    getCategoryName (id) {
      const lang = this.lang.default
      const category = this.category
      const flatten = function () {
        let result = []
        const flattenArray = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              flattenArray(x.children)
            }
            return result.push({
              id: x.data.id,
              label: x.data.label
            })
          })
          return result
        }
        return flattenArray(category)
      }
      const flattenCategory = flatten()
      return flattenCategory.find(x => x.id === id).label[lang]
    },
    onClose () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    onApply () {
      if (window.confirm(this.locale.confirm_product_set_order)) {
        const filtered = this.filtered
        this.$store.commit('product/setOrder', filtered)
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 800px;
  height: 100%;
}
.setOrder {
  height: 100%;
  overflow: auto;
  .item {
    cursor: move;
    background-color: $color-white;
  }
  .hide {
    display: none !important;
  }
}
.setApply {
  width: 180px;
  margin: 30px auto 0;
}
.category {
  .btn {
    min-width: 80px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
.productItem {
  cursor: move;
  .name {
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }
  padding-bottom: 15px;
}
.subCategory {
  button {
    position: relative;
    padding-left: 16px;
    color: $color-dgrey;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      border-radius: 100%;
      border: 1px solid $color-lgrey2;
      background-color: $color-white;
    }
    &.checked {
      color: $color-dark;
      &:before {
        width: 4px;
        height: 4px;
        border: 4px solid $color-lgrey;
      }
    }
    & + button {
      margin-left: 12px;
    }
  }
}
.itemCategory {
  padding-left: 5px;
  span {
    display: inline-block;
    margin: 4px 0 0 4px;
    padding: 1px 4px;
    font-size: 10px;
    color: $color-lgrey;
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
  }
}
</style>
